import * as React from 'react'

function IconVK(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.78 0h30.44A6.78 6.78 0 0144 6.78v30.44A6.78 6.78 0 0137.22 44H6.78A6.78 6.78 0 010 37.22V6.78A6.779 6.779 0 016.78 0z"
        fill="#4D74A5"
      />
      <path
        d="M21.631 30.802h1.8s.543-.06.821-.36c.256-.275.247-.79.247-.79s-.035-2.415 1.086-2.77c1.105-.352 2.525 2.334 4.027 3.365 1.138.78 2 .61 2 .61l4.021-.057s2.103-.13 1.106-1.784c-.082-.134-.581-1.222-2.991-3.459-2.521-2.34-2.183-1.961.854-6.01 1.849-2.465 2.59-3.971 2.358-4.615-.221-.613-1.58-.45-1.58-.45l-4.528.027s-.336-.045-.585.104c-.243.146-.4.486-.4.486s-.716 1.907-1.672 3.53c-2.016 3.423-2.822 3.605-3.152 3.393-.767-.496-.574-1.99-.574-3.052 0-3.318.503-4.701-.98-5.059-.492-.12-.854-.197-2.113-.21-1.615-.017-2.983.004-3.757.383-.515.252-.912.816-.67.848.3.039.978.182 1.336.672.464.63.448 2.048.448 2.048s.267 3.906-.622 4.392c-.61.333-1.447-.347-3.244-3.453-.921-1.591-1.617-3.349-1.617-3.349s-.135-.33-.373-.505c-.29-.213-.696-.28-.696-.28l-4.302.028s-.646.018-.882.3c-.21.249-.018.767-.018.767s3.369 7.88 7.183 11.852c3.499 3.637 7.47 3.398 7.47 3.398z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconVK
